import * as React from 'react';
import EmbeddedPowerBIReport from '../../../../../components/Reporting';
import { Card, Paper, Tab, Tabs } from '@mui/material';
import { useSelector } from 'react-redux';
import { getProductLineTypesByCode } from '../../../../../application/redux/selectors';

import SwipeableViews from 'react-swipeable-views';

import { useState } from 'react';
import { AmType } from '../../../../../types/types.type';
import { ReportingTabProps } from '../../../../../types/reporting.type';

const ProductionReport: React.FunctionComponent<ReportingTabProps> = (props) => {
    const { reportName } = props;
    const productLineTypes: Record<string, AmType> = useSelector(getProductLineTypesByCode);

    const [tabValue, setTabValue] = useState<number>(0);

    const PRODUCTION_REPORT_IDS = {
        COMMERCIAL_PROPERTY: 'ec4f1a10-6664-43c6-9ce1-5955e299df36',
        GENERAL_LIABILITY: '54721503-bc10-46c9-8436-783faba0e392',
    };
    const PRODUCTION_WORKSPACE_ID = '5969b83e-5d39-4154-ad43-a016b71cd9e0';

    return (
        <>
            <Card>
                <Paper square style={{ width: 'fit-content', marginBottom: '18px' }}>
                    <Tabs
                        value={tabValue}
                        indicatorColor={'secondary'}
                        textColor={'inherit'}
                        onChange={(e, v) => setTabValue(v)}
                        aria-label="agent submission secondary tabs"
                        variant={'scrollable'}
                        scrollButtons={'auto'}
                    >
                        {Object.values(productLineTypes).map((plt: any) => (
                            <Tab key={plt.code} label={plt.displayValue} />
                        ))}
                    </Tabs>
                </Paper>
                <SwipeableViews index={tabValue} onChangeIndex={(val) => setTabValue(val)}>
                    {Object.values(productLineTypes).map((plt: any) => (
                        <EmbeddedPowerBIReport
                            key={plt.code + '-production-report-page'}
                            reportId={PRODUCTION_REPORT_IDS[plt.code]}
                            workspaceId={PRODUCTION_WORKSPACE_ID}
                            hideFilters
                            isPrimaryReport
                            reportName={plt.code + reportName}
                        />
                    ))}
                </SwipeableViews>
            </Card>
        </>
    );
};

export default ProductionReport;
